import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Heading } from '@components/Heading';
import { Button } from '@components/Button';
import { useAuthHttp } from '../../hooks';
import { MAKE_PAYMENT } from '../../constants';
import { FloxSpinner } from '@tailwindComponents/FloxSpinner';

export function UpdatePaymentConsent() {
  const authHttp = useAuthHttp();
  const [isUpdating, setIsUpdating] = useState(true);
  const [hasErrored, setHasErrored] = useState(false);
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const handleUpdatePaymentConsent = async () => {
    setHasErrored(false);
    const oneTimeToken = searchParams.get('one-time-token');
    const paymentIdempotencyId = searchParams.get('paymentIdempotencyId');
    const reference = searchParams.get('reference');
    const billingCycleIds = searchParams.getAll('billingCycleId');

    try {
      // eslint-disable-next-line no-alert
      const { data } = await authHttp.post(
        MAKE_PAYMENT,
        {
          oneTimeToken,
          paymentIdempotencyId,
          reference,
          billingCycleIds,
        },
        { headers: { 'Content-Type': 'application/json' } }
      );
      if (data.payment) {
        navigate(`/payment/${data.payment.id}?justPaid=true`);
      }
    } catch (error) {
      setHasErrored(true);
      let returnUrl = `/invoice/pay?error`;
      billingCycleIds.forEach((id) => {
        returnUrl += `?billingCycleId=${id}`;
      });

      navigate(returnUrl);
    }
  };

  useEffect(() => {
    handleUpdatePaymentConsent();
  }, []);

  if (hasErrored) {
    return (
      <div className='flex flex-col justify-center items-center h-[50vh]'>
        <Heading as='h3' size='xs' className='mb-4'>
          Failed to update bank account consent. Please try again.
        </Heading>
        <Button onClick={handleUpdatePaymentConsent}>Retry</Button>
      </div>
    );
  }

  if (isUpdating) {
    return (
      <div className='flex justify-center items-center h-[50vh]'>
        <div className='flex flex-col items-center gap-16'>
          <Heading as='h3' size='xs'>
            Authorising payment consent...
          </Heading>
          <FloxSpinner size='lg' />
        </div>
      </div>
    );
  }

  return (
    <div className='flex justify-center items-center h-[50vh]'>
      <Heading as='h3' size='xs'>
        Failed to update payment consent. Please try again.
      </Heading>
    </div>
  );
}
